/**
 * Alt text and long description for the pool room banner photo.
 * Written for local SEO — Dublin city centre pool tables — and
 * accessibility (screen readers). Keep the alt line under ~160 chars.
 */
export const poolRoomBannerAlt =
  "Plunkets Pub pool room in Dublin city centre — three full-size pool tables under warm pendant lights on Middle Abbey Street, Dublin 1.";

export const poolRoomBannerDescription =
  "Interior photograph of Plunkets Pub on Middle Abbey Street, Dublin 1, showing the dedicated pool room in Dublin city centre. Three full-size pool tables sit side by side under warm pendant lighting, with proper cues racked on the wall and space for spectators. Plunkets offers 3 pool tables for hire at €12 per hour and 3 dart boards for hire at €15 per hour, open until 23:30 daily, 00:30 Fri & Sat, alongside 12 large TVs showing live GAA, Premier League and international sport.";
